import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class StockPropertyReferenceService extends BaseReferenceService {
  constructor() {
    super('StockPropertyReference');
  }
}
